import Vue from 'vue'
import Vuex from 'vuex'
import shared from './shared'
import snackbar from './snackbar'

import { regiesterRest } from './restStores'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    shared,
    snackbar,
  },
})

regiesterRest(store)

export default store
